/**
 * RL-954 service ratings patients give after a visit in the app (staff
 * `GET /visit-ratings`, `complaints:read`). Service only, never the doctor.
 * Shapes follow ommri-care-api `registers/visit-ratings.ts`.
 */
export const RATING_ASPECTS = [
  'waiting',
  'cleanliness',
  'staff',
  'billing',
] as const;
export type RatingAspect = (typeof RATING_ASPECTS)[number];

export interface AspectAverage {
  aspect: RatingAspect;
  /** 1 decimal; null when nobody rated this aspect. */
  average: number | null;
  count: number;
}

export interface StaffVisitRating {
  id: string;
  /** The queue ticket. */
  visitId: string;
  visitDate: string;
  branch: { id: string; name: string };
  patient: { id: string; fullName: string };
  stars: Record<RatingAspect, number | null>;
  /** null when none was written, or erased with the patient's app account (RL-955). */
  comment: string | null;
  /** A 1- or 2-star answer. */
  low: boolean;
  createdAt: string;
}

export interface VisitRatingList {
  periodDays: number;
  ratedVisits: number;
  lowRatings: number;
  aspects: AspectAverage[];
  /** Newest first, at most 200. */
  ratings: StaffVisitRating[];
}
